import React from "react";

const PurchaseProfileBuyerAgentDesc = () => {
  return (
    <div className="static-Bid-Content">
      <p className="below-static-content">
        * Buyer confirms that Buyer is not working with a licensed real estate
        agent and has not received assistance from a licensed real estate agent
        with respect to this property.
      </p>
      <p className="second-static-content">
        * Buyer understands and acknowledges that the listing broker may
        exclusively represent the seller and as such, is not in a position to
        offer guidance or advice to Buyer.
      </p>
    </div>
  );
};

export default PurchaseProfileBuyerAgentDesc;
